import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://finops-portal.angel-admin.angelstudios.com';

// Create axios instance with proper configuration for IAM auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth headers from cookies if they exist
apiClient.interceptors.request.use(
  (config) => {
    // The auth cookies will be sent automatically with withCredentials: true
    // The backend middleware will extract them from the request
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('401 Unauthorized:', {
        url: error.config?.url,
        method: error.config?.method,
        withCredentials: error.config?.withCredentials,
        headers: error.config?.headers,
      });
      // Don't auto-redirect - let the component handle the error
    }
    return Promise.reject(error);
  }
);

export default apiClient;
